import React from "react";
import PropTypes from "prop-types";
import getMuiTheme from "material-ui/styles/getMuiTheme";
import * as firebase from "firebase";
import moment from "moment";
import { Dialog, FlatButton, Card, CardText } from "material-ui";
import { connect } from "react-redux";
import { Switch, Route, withRouter } from "react-router-dom";
import GoogleLogin from "react-google-login";
import { commitMutation, graphql } from "react-relay";
import ExecutionEnvironment from "exenv";
import { StyleSheet, css } from "aphrodite";

import { Header, NavBar, Body } from "../Container";
import OurismanTravelTheme from "../../ourismanTravelTheme";
import { Trips } from "../Trips";
import { InquiryForm } from "../Inquiry";
import { Vendors, MergeVendors } from "../Vendors";
import { Clients } from "../Clients";
import { SegmentDetail } from "../Segments";
import * as AuthActions from "../../store/actions/AuthActions";
import environment from "../../relay/environment";
import * as ResponsiveActions from "../../store/actions/ResponsiveActions";
import { Responses } from "../Forms";
import { Reports } from "../Reports";
import Dashboard from "../Dashboard";
import { RateQuoteGenerator } from "../RateQuoteGenerator";

@connect(state => ({
  version: state.Auth.get("version"),
  username: state.Auth.get("username"),
  authenticated: state.Auth.get("authenticated")
}))
class AppContainer extends React.Component {
  static propTypes = {
    version: PropTypes.string.isRequired,
    username: PropTypes.string.isRequired,
    authenticated: PropTypes.bool.isRequired,
    history: PropTypes.shape({
      push: PropTypes.func
    }).isRequired,
    dispatch: PropTypes.func.isRequired
  };

  static defaultProps = {
    username: ""
  };

  constructor(props) {
    super(props);
    this.state = {
      release: "",
      timestamp: "",
      serverRelease: "",
      serverTimestamp: "",
      acknowledged: false
    };
  }

  getChildContext() {
    return {
      muiTheme: getMuiTheme(OurismanTravelTheme)
    };
  }

  handleResize = () => {
    const { dispatch } = this.props;

    dispatch(ResponsiveActions.updateWindowWidth(window.innerWidth));
    dispatch(ResponsiveActions.updateWindowHeight(window.innerHeight));
  };

  componentWillMount = () => {
    if (ExecutionEnvironment.canUseDom) {
      this.handleResize();
    }
  };

  componentDidMount = () => {
    this.checkVersion();
    this.handleResize();
    window.addEventListener("resize", this.handleResize);
    const storedJWT = localStorage.getItem("PPJWT");
    if (storedJWT) {
      this.logIn({ ppToken: storedJWT });
    }
  };

  componentWillUnmount = () => {
    window.removeEventListener("resize", this.handleResize);
  };

  componentDidUpdate() {
    this.checkVersion();
  }

  checkVersion = () => {
    const { version: release, username } = this.props;

    if (username === "" || release === "LOCALDEV") {
      return;
    }

    const config = {
      apiKey: "AIzaSyB6MhtMfMoe1bcATV_JSm0poKsdzEmRjUE",
      authDomain: "ping-pong-1322.firebaseapp.com",
      databaseURL: "https://ping-pong-1322.firebaseio.com",
      storageBucket: "ping-pong-1322.appspot.com",
      messagingSenderId: "980255644690"
    };
    if (!firebase.apps.length) {
      firebase.initializeApp(config);
    }
    const database = firebase.database();
    database.ref(`clients/${username}`).set({
      release,
      timestamp: moment().format()
    });

    database.ref("server/frontend").on("value", snapshot => {
      const {
        release: serverRelease,
        timestamp: serverTimestamp
      } = snapshot.val();
      if (
        release !== this.state.release ||
        serverRelease !== this.state.serverRelease
      ) {
        this.setState({ release, serverRelease, serverTimestamp });
      }
    });
  };

  acknowledge = () => {
    this.setState({
      acknowledged: true
    });
  };

  authSuccess = response => {
    const { tokenId } = response;
    this.logIn({ gidToken: tokenId });
  };

  authFailure = () => {
    this.props.dispatch(AuthActions.logout());
  };

  logIn = input => {
    commitMutation(environment, {
      mutation: graphql`
        mutation AppContainer_LogIn_Mutation($input: LogInInput!) {
          logIn(input: $input) {
            token {
              token
              user {
                id
                username
                firstName
                lastName
                isStaff
                isSuperuser
                groups
              }
            }
          }
        }
      `,
      variables: { input },
      onCompleted: response => {
        const {
          logIn: { token }
        } = response;

        if (token === null) {
          this.props.dispatch(AuthActions.logout());
        } else {
          const {
            token: ppjwt,
            user: {
              id,
              username,
              firstName,
              lastName,
              isStaff,
              isSuperuser,
              groups
            }
          } = token;

          localStorage.setItem("PPJWT", ppjwt);
          this.props.dispatch(
            AuthActions.setAuthData({
              authenticated: true,
              ppjwt,
              id,
              username,
              firstName,
              lastName,
              isStaff,
              isSuperuser,
              groups
            })
          );
        }
      },
      onError: err => alert(err)
    });
  };

  render() {
    const { authenticated, history } = this.props;
    const {
      release,
      serverRelease,
      serverTimestamp,
      acknowledged
    } = this.state;

    const displayServerTimestamp = moment(serverTimestamp).fromNow();

    // TODO: figure out what's up with Firebase and turn this back on!
    // const outOfDate = release !== serverRelease && !acknowledged;
    const outOfDate = false;

    const actions = [
      <FlatButton label="Acknowledge" primary onTouchTap={this.acknowledge} />
    ];

    return (
      <div id="app-container">
        <Dialog
          title="Ping Pong has Been Updated"
          modal
          open={outOfDate}
          actions={actions}
        >
          Ping Pong has been updated to version {serverRelease} as of&nbsp;
          {displayServerTimestamp}. You are still using version {release}.
          Please reload the page once you have completed what you are currently
          working on.
        </Dialog>
        <Header history={history} />
        <NavBar />
        <Body>
          {authenticated ? (
            <Switch>
              <Route exact path="/" component={Dashboard} />
              <Route
                path="/trips/:tripId/segments/:segmentId/"
                component={SegmentDetail}
              />
              <Route path="/trips/:tripId?" component={Trips} />
              <Route path="/quote/" component={RateQuoteGenerator} />
              <Route path="/inquiry/" component={InquiryForm} />
              <Route path="/reports/:selectedTab?" component={Reports} />
              <Route
                path="/vendors/:toKeepId/merge/:toMergeId/"
                component={MergeVendors}
              />
              <Route path="/vendors/:vendorId?" component={Vendors} />
              <Route path="/clients/:clientId?" component={Clients} />
              <Route
                path="/forms/responses/:responseId?"
                component={Responses}
              />
            </Switch>
          ) : (
            <div className={css(styles.loggedOut)}>
              <Card className={css(styles.logInBox)}>
                <CardText>
                  <div className={css(styles.logInBoxContent)}>
                    <p>You are not currently logged in</p>
                    <GoogleLogin
                      clientId="980255644690-l42ac2t0r87qam6mg89bcs8g0f3jiffc.apps.googleusercontent.com"
                      onSuccess={this.authSuccess}
                      onFailure={this.authFailure}
                      prompt="select_account"
                      className={css(styles.buttonStyle)}
                      redirectUri="https://ourismantravel.pingpong.travel/accounts/google/login/callback/"
                    />
                  </div>
                </CardText>
              </Card>
            </div>
          )}
        </Body>
      </div>
    );
  }
}

AppContainer.WrappedComponent.childContextTypes = {
  muiTheme: PropTypes.object
};

export default withRouter(AppContainer);

const styles = StyleSheet.create({
  loggedOut: {
    display: "flex",
    height: "calc(100vh - 64px)",
    justifyContent: "center"
  },
  logInBox: {
    alignSelf: "center",
    fontSize: 14,
    fontWeight: "bold",
    marginBottom: 5
  },
  buttonStyle: {
    background: OurismanTravelTheme.palette.accent1Color,
    border: "1px solid transparent",
    borderRadius: 2,
    color: OurismanTravelTheme.palette.canvasColor,
    display: "inline-block",
    fontSize: 16,
    fontWeight: "bold",
    paddingBottom: 10,
    paddingTop: 10,
    width: 190
  },
  logInBoxContent: {
    alignItems: "center",
    display: "flex",
    flexDirection: "column"
  }
});



// WEBPACK FOOTER //
// /src/components/AppContainer/AppContainer.js